import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  pageHeader: {
    fontSize: '150%',
    paddingLeft: '10px',
    borderBottom: '1px solid #eee',
    color: '#333',
    marginBottom: theme?.spacing(2.5),
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme?.spacing(4),
    width: '100%',
    marginRight: theme?.spacing(2.5),
  },
}));
